<header class="header" [ngClass]="{'header--sticky': stickyHeader}">
    <div class="header__container">
        <a [routerLink]="['/']" class="header__logo">
            <img src="../../../../assets/svg/solidrange-center.svg" />
        </a>
        <button *ngIf="commonService.isMobile" class="header__btn-book-demo-mobile" l10nTranslate [routerLink]="['/contact-us']">Request a demo</button>
        <!-- <a  *ngIf="commonService.isMobile" href="tel:+9660558188338" class="header__mobile-call">
          <mat-icon [svgIcon]="'telephone'"></mat-icon>
        </a> -->
      <mat-icon (click)="toggleSideMenu()" [ngClass]="{'header-holder-icon-menu-active': commonService.sideMenuOpen}" class="header__menu" [svgIcon]="commonService.sideMenuOpen?'arrow-menu': 'menu'"></mat-icon>
        <div class="header__holder" *ngIf="!commonService.isMobile"  [ngClass]="{'header-holder--active': commonService.sideMenuOpen}" >
            <nav class="header__nav">
                <ul class="header__list">
                    <li>
                        <a class="header__link header__link--has-sub-links" (click)="openMenu('products')" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'products'}" l10nTranslate>
                            Products
                        </a>
                      <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'products'}">
                        <div class="header__sub-menu-holder">
                          <div class="header__sub-menu-links-block">
                            <ul>
                              <li *ngFor="let item of subHeaderData" (mouseenter)="hoverMenuSubMenu(item)">
                                <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">

                                  <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                                  <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                                  </div>

                                </a>
                              </li>

                            </ul>
                          </div>


                        </div>

                      </div>
                    </li>

                    <li>
                        <a (click)="openMenu('Services')" class="header__link header__link--has-sub-links" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'Services'}" l10nTranslate>
                            Services
                        </a>

                        <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'Services'}">
                          <div class="header__sub-menu-holder">
                            <div class="header__sub-menu-links-block">
                              <ul>
                                <li *ngFor="let item of subHeaderServicesData" (mouseenter)="hoverMenuSubMenu(item)">
                                  <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                                    <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                                    <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                                    </div>
                                  </a>
                                </li>

                              </ul>
                            </div>


                          </div>

                        </div>
                    </li>

                    <!-- <li> <a (click)="menuClick()" class="header__link" [routerLink]="['/contact-us']" l10nTranslate>
                            Resources
                        </a></li> -->

                    <li>
                        <a  (click)="openMenu('Company')" class="header__link header__link--has-sub-links" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'Company'}" l10nTranslate>
                            Company
                        </a>
                        <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'Company'}">
                          <div class="header__sub-menu-holder">
                            <div class="header__sub-menu-links-block">
                              <ul>
                                <li *ngFor="let item of subHeaderCompanyData" (mouseenter)="hoverMenuSubMenu(item)">
                                  <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                                    <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                                    <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                                    </div>
                                  </a>
                                </li>

                              </ul>
                            </div>


                          </div>

                        </div>
                    </li>
                </ul>
            </nav>
          <div class="header__sub-links">
            <a  *ngIf="commonService.isMobile" class="header__link-language" l10nTranslate (click)="setLocale()">English</a>

            <button *ngIf="!commonService.isMobile"  class="header__btn-book-demo" l10nTranslate [routerLink]="['/contact-us']">Request a demo</button>
            <button (click)="openMenu('contacUs')" class="header__btn-contact-us header__link--has-sub-links" l10nTranslate [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'contacUs'}">Contact us
              <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'contacUs'}">
                <div class="header__sub-menu-holder">
                  <div class="header__sub-menu-links-block">
                    <ul>
                      <li *ngFor="let item of subHeaderContactUsData" (mouseenter)="hoverMenuSubMenu(item)">
                        <a *ngIf="item.id !== 1 &&  item.id != 2" (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                          <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                          <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                          </div>
                        </a>
                        <!-- <a  *ngIf="item.id == 1" (click)="menuClick()" [href]="item?.tel" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                          <div class="header__sub-menu-link-icon"><mat-icon class="header__telephone-icon" [svgIcon]="item.iconName"></mat-icon></div>
                          <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                          </div>
                        </a> -->
                        <a  *ngIf="item.id == 2" (click)="menuClick()" target="_blank" [href]="'https://wa.me/+966550722030'" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                          <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                          <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                          </div>
                        </a>
                      </li>

                    </ul>
                  </div>


                </div>

              </div>
            </button>


            <a *ngIf="!commonService.isMobile" class="header__link-language" l10nTranslate (click)="setLocale()">English</a>
          </div>
        </div>


    </div>
</header>

<div *ngIf="commonService.isMobile" class="header__holder"  [ngClass]="{'header-holder--active': commonService.sideMenuOpen}" >
  <nav class="header__nav">
    <ul class="header__list">
      <li>
        <a class="header__link header__link--has-sub-links" (click)="openMenu('products')" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'products'}" l10nTranslate>
          Products
        </a>
        <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'products'}">
          <div class="header__sub-menu-holder">
            <div class="header__sub-menu-links-block">
              <ul>
                <li *ngFor="let item of subHeaderData" (mouseenter)="hoverMenuSubMenu(item)">
                  <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">

                    <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                    <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                    </div>

                  </a>
                </li>

              </ul>
            </div>


          </div>

        </div>
      </li>

      <li>
        <a (click)="openMenu('Services')" class="header__link header__link--has-sub-links" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'Services'}" l10nTranslate>
          Services
        </a>

        <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'Services'}">
          <div class="header__sub-menu-holder">
            <div class="header__sub-menu-links-block">
              <ul>
                <li *ngFor="let item of subHeaderServicesData" (mouseenter)="hoverMenuSubMenu(item)">
                  <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                    <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                    <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                    </div>
                  </a>
                </li>

              </ul>
            </div>


          </div>

        </div>
      </li>

      <!-- <li> <a (click)="menuClick()" class="header__link" [routerLink]="['/contact-us']" l10nTranslate>
              Resources
          </a></li> -->

      <li>
        <a  (click)="openMenu('Company')" class="header__link header__link--has-sub-links" [routerLink]="['/contact-us']" [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'Company'}" l10nTranslate>
          Company
        </a>
        <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'Company'}">
          <div class="header__sub-menu-holder">
            <div class="header__sub-menu-links-block">
              <ul>
                <li *ngFor="let item of subHeaderCompanyData" (mouseenter)="hoverMenuSubMenu(item)">
                  <a (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                    <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                    <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}<span l10nTranslate>{{item.subTitle}}</span></div>
                    </div>
                  </a>
                </li>

              </ul>
            </div>


          </div>

        </div>
      </li>
    </ul>
  </nav>
  <div class="header__sub-links">
    <a  *ngIf="commonService.isMobile" class="header__link-language" l10nTranslate (click)="setLocale()">English</a>

    <button class="header__btn-book-demo" (click)="menuClick()" l10nTranslate [routerLink]="['/contact-us']">Request a demo</button>
    <button (click)="openMenu('contacUs')" class="header__btn-contact-us header__link--has-sub-links" l10nTranslate [ngClass]="{'header__link--has-sub-links--active': openedMenuItem === 'contacUs'}">Contact us

    </button>
    <div class="header__sub-menu" [ngClass]="{'header__sub-menu--active': openedMenuItem === 'contacUs'}">
      <div class="header__sub-menu-holder">
        <div class="header__sub-menu-links-block">
          <ul>
            <li *ngFor="let item of subHeaderContactUsData" (mouseenter)="hoverMenuSubMenu(item)">
              <a *ngIf="item.id !== 1 &&  item.id != 2" (click)="menuClick()" [routerLink]="[item.link]" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                </div>
              </a>
              <!-- <a  *ngIf="item.id == 1" (click)="menuClick()" [href]="item?.tel" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                </div>
              </a> -->
              <a  *ngIf="item.id == 2" (click)="menuClick()" target="_blank" [href]="'https://wa.me/+966550722030'" class="header__sub-menu-link" [ngClass]="{'header__sub-menu-link--active': selectedSubHeaderInfo.id=== item.id}">
                <div class="header__sub-menu-link-icon"><mat-icon [svgIcon]="item.iconName"></mat-icon></div>
                <div class="header__sub-menu-link-text"><div l10nTranslate>{{item.title}}</div>
                </div>
              </a>
            </li>

          </ul>
        </div>


      </div>

    </div>
    <!-- <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <span>Redial</span>
      </button>
      <button mat-menu-item>
        <span>Disable alerts</span>
      </button>
    </mat-menu> -->

    <a *ngIf="!commonService.isMobile" class="header__link-language" l10nTranslate (click)="setLocale()">English</a>
  </div>
</div>
